import * as Sentry from '@sentry/angular';

export const throwSentryError = (key: string, value: unknown) => {
  const scope = new Sentry.Scope();
  scope.setExtra(key, value);
  Sentry.captureException(new Error(key), scope);
};
